import useAppUser from 'hooks/useAppUser';
import { UserType } from 'models/Users';
import PublicLayout from 'pages/_layouts/publicLayout/PublicLayout';
import {
  Navigate,
  Outlet,
  useLocation,
  useSearchParams,
} from 'react-router-dom';
import { subscriptionErrorParamName } from '../pages/login/Login.constants';

function shouldAlwaysRenderRequestedPage({
  pathname,
  searchParams,
}: {
  pathname: string;
  searchParams: URLSearchParams;
}) {
  // if user is already logged in mobile browser, and the URL contains mobile app,
  // then we should clean the localStorage and redirect to the login page:
  const isLoginPageFromMobile = searchParams
    .get('clientId')
    ?.startsWith('pmpMobile_');

  return (
    isLoginPageFromMobile ||
    pathname.startsWith('/register') ||
    !!searchParams.get(subscriptionErrorParamName)
  );
}

function shouldRenderOAuthContinuationPage({
  pathname,
  searchParams,
}: {
  pathname: string;
  searchParams: URLSearchParams;
}) {
  const isLoginPageFromMobile = searchParams
    .get('clientId')
    ?.startsWith('pmpMobile_');

  return (
    pathname === '/login' &&
    !!searchParams.get('redirectUri') &&
    !isLoginPageFromMobile
  );
}

const PublicRoute = () => {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const { userType } = useAppUser();
  const hasAccessToken = localStorage.getItem('access_token');

  if (shouldAlwaysRenderRequestedPage({ pathname, searchParams })) {
    localStorage.removeItem('access_token');
    return (
      <PublicLayout>
        <Outlet />
      </PublicLayout>
    );
  }

  if (shouldRenderOAuthContinuationPage({ pathname, searchParams })) {
    return (
      <PublicLayout>
        <Outlet />
      </PublicLayout>
    );
  }

  if (userType && hasAccessToken) {
    const initialPageRedirection = {
      [UserType.ServiceProviderUser]: '/service-provider/dashboard',
      [UserType.Employee]: '/dashboard',
      [UserType.Owner]: '/owner/calendar',
      [UserType.Agent]: '/agent/dashboard', // FIXME: [UserType.Agent] doesnt have a dashboard (dashboard_agent.jsp empty);
    };
    return <Navigate to={initialPageRedirection[userType] || '/dashboard'} />;
  }

  return !hasAccessToken ? (
    <PublicLayout>
      <Outlet />
    </PublicLayout>
  ) : (
    <Navigate to="/dashboard" />
  );
};

export default PublicRoute;
